import ko from "knockout";
import uly from "ulysses/base";

export class Columns {
    
    constructor(columns) {
        this.main_columns = columns.main_columns;
        this.extra_columns = columns.extra_columns;
        this.columns = ko.observableArray(_compute_columns(columns.main_columns, columns.extra_columns));
        this.flat_columns = ko.pureComputed(() => this.columns().reduce((res, cat) => res.concat(cat.columns), []));
        this.configs = ko.observableArray([]);
        this.filter = ko.observable(null);
        this.extra = ko.observable(false);
        this._last_idx = 0;

        this.selected_columns = ko.pureComputed(() => {
            return this.flat_columns()
                .filter((v) => { return v && v.included(); })
                .sort((a,b) => { return a.index() - b.index(); });
        });
        
        this.visible_selected_columns = ko.pureComputed(() => {
            var vals = this.selected_columns();
            var filter = this.filter();
            if(!filter) {
                return vals;
            } else {
                var tokens = filter.toLowerCase().split(" ");
                return vals.filter((val) => {
                    if (!val) return false;
                    for (var tok_i in tokens) {
                        var tok = tokens[tok_i];
                        if (!tok) continue;
                        if (!(
                            (val.caption && val.caption.toLowerCase().indexOf(tok) >= 0)  ||
                            (val.field_name && val.field_name.toLowerCase().indexOf(tok) >= 0)
                        ))
                        return false;
                    }
                    return true;
                });
            }
        });
        
        this.visible_available_columns = ko.pureComputed(() => {
            var filter = this.filter();
            var res = [];
            var tokens = filter ? filter.toLowerCase().split(" ") : [];
            this.columns().forEach((cat)=> {
                var cols = cat.columns.filter((col) => !col.included());
                if (filter) {
                    cols = cols.filter((val) => {
                        if (!val) return false;
                        for (var tok_i in tokens) {
                            var tok = tokens[tok_i];
                            if (!tok) continue;
                            if (!(
                                (val.caption && val.caption.toLowerCase().indexOf(tok) >= 0)  ||
                                (val.field_name && val.field_name.toLowerCase().indexOf(tok) >= 0)
                            ))
                            return false;
                        }
                        return true;
                    });
                }
                if (cols.length > 0) {
                    res.push({ "name": cat.name, "caption": cat.caption, "expanded": cat.expanded, "columns": cols, "count": cols.length });
                }
            });
            return res;
        });
                
    }

    toggle_extra() {
        this.extra(!this.extra());
    }


    clear_selection() {
        this.flat_columns().forEach((col) => {
            col.included(false);
        });
        this._last_idx = 0;
    }

    select_all() {
        this.flat_columns().forEach((col) => {
            if (!col.included()) {
                col.included(true);
                col.index(this._last_idx++);
            }
        });
    }

    select_column(col) {
        console.log("Arguments:", arguments);
        if (!col.included()) {
            col.index(this._last_idx++);
            col.included(true);
            console.log("Included:", this._last_idx);
        }
    }

    remove_column(col) {
        col.included(false);
    }

    move_up(col) {
        //do something!
        var cols = this.selected_columns();
        var idx_ = cols.indexOf(col);
        if(idx_ > 0) {
            var prev = cols[idx_-1].index();
            cols[idx_-1].index(col.index());
            col.index(prev);
        }
        return false;
    }

    move_down(col) {
        //do something!
        var cols = this.selected_columns();
        var idx_ = cols.indexOf(col);
        if(idx_ < cols.length - 1) {
            var next = cols[idx_+1].index();
            cols[idx_+1].index(col.index());
            col.index(next);
        }
        return false;
    }

    include_columns(cols) {
        this.clear_selection();
        this.flat_columns().forEach((col) => {
            let _idx = cols.indexOf(col.field_name);
            if (_idx >= 0) {
                col.included(true);
                col.index(_idx);
            }
        })
        this._last_idx = cols.length + 1;
    }

    expand(cat) {
        console.log(cat);
        cat.expanded(true);
    }

    collapse(cat) {
        console.log(cat);
        cat.expanded(false);
    }

};





function _compute_columns(main_cols, extra_cols) {
    var result = []
    var cats = {};
    main_cols.forEach((cat) => {
        cat.name = cat.category;
        cat.expanded = ko.observable(false);
        cat.columns.forEach((col) => { 
            col.included = ko.observable(false);
            col.index = ko.observable(null);
        })
        result.push(cat);
        cats[cat.category] = cat;
        cat.count = cat.columns.length;
    });
    extra_cols.forEach((cat) => {
        cat.name = cat.category;
        cat.expanded = ko.observable(false);
        cat.columns.forEach((col) => { 
            col.included = ko.observable(false);
            col.index = ko.observable(null);
        })
        if (cats[cat.category]) {
            cats[cat.category].columns = cats[cat.category].columns.concat(cat.columns);
        } else {
            cats[cat.category] = cat;
            result.push(cat);
        }
        cats[cat.category].count = cats[cat.category].columns.length;
    });
    return result;
}

export default { Columns };